export const nonWorkingDates = [{
    initialDate: '2025-06-03',
    finalDate: '2025-06-07',
}];